import { type ReactNode } from 'react'
import { usePage } from '@inertiajs/react'
import { SidebarLayout } from '@/components/ui'
import { FlashToaster } from '@/components/common/FlashToaster'
import { AppSidebar } from './AppSidebar'
import { AppNavbar } from './AppNavbar'

/**
 * The authenticated app shell: Collectia-Blue sidebar + responsive mobile top
 * bar, with page content rendered on a white surface. Use as a persistent
 * Inertia layout:
 *
 *   Page.layout = (page) => <AppLayout>{page}</AppLayout>
 */
export function AppLayout({ children }: { children: ReactNode }) {
  // Key the content by the current page component so each navigation replays a
  // subtle fade (see `.page-transition` in styles/base.css). Filtering or
  // paginating within the same page keeps the same component → no re-animation.
  const { component } = usePage()

  return (
    <SidebarLayout sidebar={<AppSidebar />} navbar={<AppNavbar />}>
      <FlashToaster />
      <div key={component} className="page-transition">
        {children}
      </div>
    </SidebarLayout>
  )
}

/** Convenience for assigning a page's persistent layout. */
export const withAppLayout = (page: ReactNode) => <AppLayout>{page}</AppLayout>
